import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const res = await axios.get(`${API_URL}/institutionsAdmins`, { params: criteria });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getOne(_, institutionsAdminId) {
      const res = await axios.get(`${API_URL}/institutionsAdmins/${institutionsAdminId}`);

      if (!res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async create(_, institutionsAdminData) {
      const res = await axios.post(`${API_URL}/institutionsAdmins`, institutionsAdminData);

      if (res.status !== 201 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async update(_, { institutionsAdminId, institutionsAdminData }) {
      const res = await axios.put(
        `${API_URL}/institutionsAdmins/${institutionsAdminId}`,
        institutionsAdminData,
      );

      if (res.status !== 200 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async remove(_, institutionsAdminId) {
      const res = await axios.delete(`${API_URL}/institutionsAdmins/${institutionsAdminId}`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async activate(_, institutionsAdminId) {
      const res = await axios.post(`${API_URL}/institutionsAdmins/${institutionsAdminId}/activate`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async deactivate(_, institutionsAdminId) {
      const res = await axios.post(
        `${API_URL}/institutionsAdmins/${institutionsAdminId}/deactivate`,
      );

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};

export default store;
